<template>
  <div class="field tag-list">
    <label :for="name">{{labelText}} <em class="optional" v-if="!required">optional</em><em class="required" v-if="required">*</em></label>
    <div class="tag-list--input">
      <div class="input-wrapper">
        <input @keyup.enter.prevent="addOrRemoveTag"
          @keyup.space="addTagKey"
          @keyup.comma="addTagKey"
          @focus="emitFocus"
          @blur="emitBlur"
          :disabled="disabled"
          v-model="tag"
          type="text"
          :id="name"
          :name="name"
          :class="getClass()"
        >
        <i
          class="add icon yule-icon-circle-plus"
          @click="addOrRemoveTag"
        />
      </div>
      <div class="tag-list--item" v-for="(item, index) in value" :key="index">
        <span>{{ item.length > 15 ? `${item.slice(0, 15)}…` : item }}</span>
        <i class="icon tag-list--icon remove yule-icon-close-small" @click="removeTag(index)" v-if="!isProtected(item)"></i>
        <i class="icon tag-list--icon yule-icon-lock" v-else></i>
      </div>
    </div>
    <p v-if="error" class="validation-message">{{$t(error)}}</p>
  </div>
</template>
<script>
export default{
  props: {
    label: String,
    classes: Array,
    name: String,
    value: Array,
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      newValue: Array,
      displayOnlyTags: [],
      error: '',
      tag: '',
      regex: /^[-a-zA-Z0-9äöüÄÖÜß_]*$/,
      backspace_count: 1,
      displayTagsInitialized: false
    }
  },
  mounted() {
    // reset displayTags
    this.displayOnlyTags = []

    // listens to tag adding from the tag enrichment feature
    EventBus.$on('enrich_tags', (tag, removeIfExists) => {
      if(tag) {
        this.tag = tag
        this.displayOnlyTags.push(this.tag)
        this.addOrRemoveTag(removeIfExists)
      }
    })

    // if emitted, this method will add tags to the value array if it does not exist yet
    // it will also add tags to the displayOnlyTags array which then is used to decide whether a tag can be deleted or not
    EventBus.$on('enrich_tags_on_init', tags => {
      if(tags) {
        tags.forEach(tag => {
          this.tag = tag
          this.displayOnlyTags.push(this.tag)
          // prevent multiple tags of the same value in the value array
          if (this.value.indexOf(tag) === -1) {
            this.addOrRemoveTag()
          }
          this.tag = ''
        })
      }
    })
  },
  methods:{
    getClass() {
      if (this.classes && this.classes.length > 0) {
        return "tag-list-input " + this.classes[0]
      } else {
        return "tag-list-input"
      }
    },
    emitBlur() {
      this.$emit('blur')
    },
    emitFocus() {
      this.$emit('focus')
    },
    // TODO: remove tag by name
    removeTag(index){
      this.value.splice(index,1)
      this.$emit('remove', this.value)
    },
    validate(tag){
      return this.regex.test(tag)
    },
    addTagKey(){
      let tag = this.tag
      this.tag = tag.substring(0, tag.length-1)
      this.addOrRemoveTag()
    },
    // if tag is in this array, it shall be protected from deletion because it was enriched automatically
    isProtected(tag) {
      let index = this.displayOnlyTags.indexOf(tag)
      return index > -1
    },
    // adds a tag
    // if requested, also removes tags. usually used when tags are added from the outside (enrich_tags)
    addOrRemoveTag(removeIfExists = false){
      if(this.tag != '') {

        let index = this.value.indexOf(this.tag)
        if(removeIfExists && (index > -1)) {
          this.removeTag(index)
          this.tag = ''
          return
        }

        if(this.validate(this.tag)) {
          this.value.push(this.tag)

          this.$emit('setTag', this.tag)
          this.error = ''
          this.tag = ''
        } else {
          this.error = "errors.lead.wrong_tag_format"
        }
      }
    }
  },
  computed: {
    labelText() {
      return this.label == 'empty' ? '' : (this.label || this.$t('ui.taglist.label'))
    }
  }
}
</script>
<style lang="scss" scoped>
.add {
  position: absolute;
  right: 10px;
  top: 50%;
  bottom: 50%;
  cursor: pointer;
}
.input-wrapper {
  position: relative;
  width: 100%;
}
.tag-list--input{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  margin-bottom:1.2em;
  max-height: 200px;
  overflow-y: auto;
}
.tag-list--item{
  display: inline-block;
  padding: 7px 12px;
  background: $paper;
  border-radius: 3px;
  user-select: none;
  margin-right: 5px;
  color: $ink-dark;
  height: 40px;
}
.tag-list--icon{
  font-size: 20px;
  display: inline-block;
  vertical-align: text-top;
  margin-left: 6px;
  opacity: .37;
  &.remove {
    cursor: pointer;
    &:hover{
      opacity: .69;
    }
  }
}
.tag-list-input{
  width: 100%;
  margin: 0 !important;
  min-width: 80px;
  border:none;
  outline: none;
  flex-grow: 1;
}
.tag-list--item,
.tag-list-input{
  margin-top: 10px;
}
.validation-message{
  color: $red;
}
</style>



// WEBPACK FOOTER //
// TagList.vue?befcf7f2